class Toast {
  constructor() {
    this.initialized = false;
    return this;
  }

  init() {
    if (!this.initialized) {
      this.toastContainer = document.createElement('div');
      this.toastContainer.className = 'toast-container';
      document.body.appendChild(this.toastContainer);
      this.initialized = true;
    }
  }

  createToast(message, type = 'info', duration = 3000) {
    this.init();
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.innerText = message;

    const closeButton = document.createElement('button');
    closeButton.className = 'toast-close';
    closeButton.innerHTML = '&times;';
    closeButton.onclick = () => this.closeToast(toast);

    toast.appendChild(closeButton);
    this.toastContainer.appendChild(toast);

    // Add has-toast class if not present
    this.toastContainer.classList.add('has-toast');

    // Trigger slide-in animation
    setTimeout(() => {
      toast.classList.add('toast-show');
    }, 10);

    setTimeout(() => {
      this.closeToast(toast);
    }, duration);
  }

  closeToast(toast) {
    if (toast && toast instanceof HTMLElement) {
      toast.classList.add('toast-hide');
      toast.addEventListener('transitionend', () => {
        toast.remove();
        // Remove has-toast class if no toasts remain
        if (this.toastContainer && this.toastContainer.children.length === 0) {
          this.toastContainer.classList.remove('has-toast');
        }
      });
    } else {
      console.error('Invalid toast element:', toast);
    }
  }

  success(message, duration) {
    this.createToast(message, 'success', duration);
  }

  error(message, duration) {
    this.createToast(message, 'error', duration);
  }

  info(message, duration) {
    this.createToast(message, 'info', duration);
  }

  warning(message, duration) {
    this.createToast(message, 'warning', duration);
  }
}

window.toast = new Toast();
